import { FC, SVGProps } from "react";

const Bag: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M28.542 8.2065C28.518 7.809 28.1895 7.5 27.7935 7.5H22.5C22.5 5.0145 20.4855 3 18 3C15.5145 3 13.5 5.0145 13.5 7.5H8.2065C7.8105 7.5 7.482 7.809 7.458 8.2065L6.0465 32.2065C6.021 32.637 6.3645 33 6.795 33H29.205C29.637 33 29.979 32.637 29.9535 32.2065L28.542 8.2065ZM18 4.5C19.6545 4.5 21 5.8455 21 7.5H15C15 5.8455 16.3455 4.5 18 4.5ZM7.5915 31.5L8.9145 9H13.5H22.5H27.0855L28.4085 31.5H7.5915Z" />
    </svg>
  );
};

export default Bag;
